<template>
<div id="payLaterWidget">
      <!-- Paypal Payments message  -->
      <template v-for="(paymentType, index) in payLaterWidget.paymentTypes">
        <template v-if="paymentType === 'PAYPAL'">
          <div class="paypal-message" v-show="!isSOREnabled"
            data-pp-message 
            :data-pp-amount="payLaterPrice"
            :data-pp-style-text-color="paypalColor"
            data-pp-style-layout="text"
            :data-pp-style-text-size="paypalFontSize"
            data-pp-style-logo-type="primary"
            data-pp-style-logo-position="left">
          </div>
        </template>
      </template>
      <!-- Klarna or Afterpay Payments message  -->
      <div v-if="payLaterWidget.paymentTypes && payLaterMonthlyValue" v-show="!isSOREnabled" class="pay-later-message">
          <div v-if="isPayLaterEligible" class="payment-message" v-html="$t('label.pay.later.payment.message.above.threshold', [payLaterInstalmentsPeriod, payLaterMonthlyValue])"></div>
          <div v-else class="payment-message" v-html="$t('label.pay.later.payment.message.below.threshold', [payLaterThreshold])"></div>
          <div class="payment-types">
           <template v-for="(paymentType, index) in payLaterWidget.paymentTypes">
            <template v-if="paymentType !== 'PAYPAL'">
                <svg :class="['svg-icon payment-svg decorative-icon',`${paymentType}-pay-later`]" :aria-label="`${paymentType}-pay-later`" focusable="false" role="img">
                  <use :href="`${sharedSvgPath}#${paymentType}-pay-later`" />
                </svg>
                <span v-if="index < payLaterWidget.paymentTypes.length - 1 && (payLaterWidget.paymentTypes.length - 2 !== index || paypalIndex -1 !== index)" class="payment-type-delimiter" v-html="$t('label.pay.later.payment.or')" ></span>
              </template>
            </template>
            <button v-if="payLaterWidget.modalBody" type="button" data-toggle="modal" data-target="#payLaterMarketingModal" class="pay-later-modal-button" :aria-label="$t('label.pay.later.payment.help')">
              <svg class="svg-icon info-svg  decorative-icon" focusable="false" role="img">
                <use :href="`${svgPath}#info`" />
              </svg>
            </button>
          </div>
      </div>
      <Teleport to="body">
        <div v-if="payLaterWidget.modalBody" class="modal fade pr-0" id="payLaterMarketingModal" role="dialog" aria-modal="true" tabindex="-1">
            <div class="modal-dialog modal-full">
                <div class="modal-content" v-html="payLaterWidget.modalBody">
                </div>
            </div>
        </div>
      </Teleport>
      <!-- Klarna or Afterpay Payments message  -->
</div>
</template>

<script>
import { mapGetters, mapActions} from "vuex";
import { EventBus } from "@/scripts/event-bus.js";
import { mapMutations, mapGetters as vue3_mapGetters } from "@/store/helper/vuex";
export default {
  name: "PayLaterWidget",
  setup() {
    const { vueVariables } = vue3_mapGetters();
    const { setVueVariables } = mapMutations();

    document.addEventListener("update-cart-variables", (event) => {
        setVueVariables(event.detail);
    });

    setVueVariables(window.vue.variables);
    
    return {
        vueVariables
    }
  },
  data() {
    return {
      svgPath: this.vueVariables.svgPath,
      sharedSvgPath: this.vueVariables.sharedLibrarySvgPath,
      payLaterMonthlyValue: null,
      payLaterInstalmentsPeriod: this.vueVariables.payLaterInstalmentsPeriod,
      payLaterThreshold: this.vueVariables.payLaterThreshold,
      isPayLaterEligible: null,
      isSOREnabled: null,
      payLaterMonthlyPDPValue: this.vueVariables.payLaterPDPMonthlyValue,
      payLaterPrice: this.vueVariables.payLaterPrice,
      isElixir: false,
      isPayLaterPDPEligible: this.vueVariables.isPayLaterPDPEligible,
      isSorPDPEnabled: this.vueVariables.isSorPDPEnabled,
      paypalFontSize: this.vueVariables.paypalMessageFontSize,
      paypalColor: 'black',
      paypalIndex: -1,
    };
  },
  methods: {
    ...mapActions({
      getPayLaterWidget: "getPayLaterWidget",
    }),
    updatePayLaterWidgetModal() {
      this.payLaterPaymentMessage.element.innerHTML = this.payLaterPaymentMessage.placeholderText.replace('{1}', this.payLaterMonthlyValue);
    },
    initPayLater() {
      const paymentMessageElement = document.querySelector('#payLaterMarketingModal .payment-message');
      if (this.payLaterWidget.modalBody) {
        this.payLaterPaymentMessage = {
          element: paymentMessageElement,
          placeholderText: paymentMessageElement.innerHTML.replace('{0}', this.payLaterInstalmentsPeriod)
        }
      }
      this.isElixir = document.querySelector('.elixir-page') ? true : false;
      if (this.isElixir) {
        var element = document.querySelector('.details-section-container .product-name');
        if (element) {
          var computedStyle = window.getComputedStyle(element);
          this.paypalColor = computedStyle.getPropertyValue('color') === 'rgb(255, 255, 255)' ? 'white' : 'monochrome';
        }
      }

      document.addEventListener("pay-later-widget-monthly-value-update", (event) => {
        let payLaterObj = event.detail;
        this.payLaterMonthlyValue = payLaterObj.monthlyInstalments; 
        this.isPayLaterEligible = payLaterObj.eligible;
        this.payLaterPrice = payLaterObj.price;
        if (this.payLaterWidget.modalBody) {
          this.updatePayLaterWidgetModal();
        }
      });

      document.addEventListener("pay-later-widget-sor-value-update", (event) => {
        this.isSOREnabled = event.detail;
      });

      if (this.payLaterWidget.paymentTypes) {
        this.paypalIndex = this.payLaterWidget.paymentTypes.indexOf('PAYPAL');
      }
    }
  },
  computed: {
    ...mapGetters({
      payLaterWidget: "payLaterWidget",
    }),
  },
  mounted() {
    if (vueCurrentActiveStates["cart"]) {
      this.getPayLaterWidget().then(() => {
        this.initPayLater();
        EventBus.$emit("pay-later-widget-mounted");
      });
    }
    if (vueCurrentActiveStates["pdp"]) {
      this.getPayLaterWidget().then(() => {
        this.initPayLater();
        this.payLaterMonthlyValue = this.payLaterMonthlyPDPValue;
        this.isSOREnabled = this.isSorPDPEnabled;
        this.isPayLaterEligible = this.isPayLaterPDPEligible;
        if (this.payLaterWidget.modalBody) {
          this.updatePayLaterWidgetModal();
        }
      });
    }
  },
};
</script>